// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .price-editor-amount {
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/price-editor/price-editor.component.scss"],"names":[],"mappings":"AAGI;EACI,eAAA;AAFR","sourcesContent":["\r\n:host ::ng-deep {\r\n    \r\n    .price-editor-amount {\r\n        font-size: 30px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
